// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"f05995cd","446":"42843d53"}[chunkId] + ".chunk.css";
};